import type { IconSvgObject } from './types';

const Facebook02Icon: IconSvgObject = [
  ["path", { d: "M13 13.5H17L18 9.5H13V7.5C13 6.47 13 5.5 15 5.5H18V2C18 2 14.943 2 13.643 2C10.928 2 9 3.657 9 6.7V9.5H5V13.5H9V22H13V13.5Z", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Facebook02Icon;
